// extracted by mini-css-extract-plugin
export default {"Services":"styles_Services__SARrb","ServicesTab":"styles_ServicesTab__k7Xc7"};